<template>
	<div class="vipgiftbaglist">
    <header>
      <img src="/static/images/VIP/vip.png">
      <van-button v-if="superinfo.supername" round type="primary" size="mini" color="#ffffff" @click="supershow = true">专属顾问&gt;</van-button>
    </header>
    <div class="content flex">
      <van-sidebar v-model="activeKey">
        <van-sidebar-item v-for="(item, index) of list" :key="index" :class="['tag'+index]" :title="item.classificationname" @click="handleClick(index)" />
      </van-sidebar>
      <div class="flex-1 productlist" ref="productlist" @scroll="scrollTop">
        <van-cell-group v-for="(item, index) of list" :key="index" :class="['list'+index]" inset>
          <van-cell class="title_bold" :title="item.classificationname" value="" />
          <van-checkbox-group v-model="result" checked-color="#FB6E38" @change="onChange">
            <van-cell v-for="(goodsitem, goodsindex) of item.itemlist" :key="goodsindex">
              <template #title>
                  <div class="flex-ac listitem">
                    <van-checkbox :name="goodsitem.chooseid"></van-checkbox>
                    <img v-lazy="goodsitem.path" alt="">
                    <div class="product flex-dc flex-js flex-1">
                      <p class="f13">{{goodsitem.name}}</p>
                      <div class=" flex-js price">
                        <span class="f14">¥{{goodsitem.price}}</span>
                        <van-stepper :long-press="false"
                                     @change="stepperFn(goodsitem)" class="goods_stepper" v-model="goodsitem.num"/>
                      </div>
                    </div>
                  </div>
              </template>
            </van-cell>
          </van-checkbox-group>
        </van-cell-group>
      </div>
    </div>
    <div class="footer">
      <van-button type="primary" size="mini" block :class="{'white': ismore == 1}" :color="(ismore == 0 || ismore == 2) ? 'rgb(222, 222, 222)' : 'linear-gradient(90deg, #FB6E38 0%, #FE9B4B 100%)'" @click="submit">
          {{result.length <= 0 ? '请选择礼包' : ismore == 0 ? ('礼包总额最低'+parseFloat(minmoney).toFixed(2)+'，还差' + gapmoney) : ismore == 2 ? ('礼包总额最高'+parseFloat(maxmoney).toFixed(2)+'，已超' + gapmoney) : '立即购买'}}
      </van-button>
      <div class="h"></div>
    </div>
    <van-overlay :show="supershow" v-if="supershow" z-index="99999">
      <div class="wrapper" >
        <div class="block" style="width: 70%" @click.stop>
          <div style="background: #ffffff;text-align: center;padding-top: 0.2rem;padding-bottom: 0.2rem;">
            <img style="width: 1.5rem;height: 1.5rem;margin: auto" v-if="superinfo.superimg" :src="superinfo.superimg">
            <b class="f16" style="display:block;margin-top: 0.15rem">{{superinfo.supername}} <span class="f10" style="color: #999;">(专属顾问)</span></b>
            <span style="display:block;color: #444;margin-top: 0.1rem" class="f12">{{superinfo.supermobile}}</span>
          </div>
          <van-icon name="close" @click="supershow = false" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Vue from 'vue';
import { isWeixin, fenxiang } from '../../assets/common/js/config'
import wx from "weixin-js-sdk";
import { Sidebar, SidebarItem } from 'vant';

Vue.use(Sidebar);
Vue.use(SidebarItem);
export default {
  name: "vipgiftbaglist",
  data () {
    return {
      activeKey: 0,
      num: 1,
      result: [],
      list: [],
      timer: null,
      totalmoney: 0,
      maxmoney: 0, // 最大购买金额
      minmoney: 0, // 最小购买金额
      gapmoney: '0.00', // 超出/不满足金额差
      ismore: 0, // 是否超过区间金额，0不满足最小金额 1可正常购买 2已超出最大金额
      shopConfirmResult: {},
      shopConfirmProductList: [],
      superinfo: {},
      supershow: false,
      paymoney: 0
    }
  },
  mounted () {
	if (isWeixin()) {
	  fenxiang({path: 'vipgiftbaglist'})
	}
    this.startSite()
  },
  methods: {
    startSite() {
      if (!isWeixin()) {
        this.$toast('请在微信使用此功能')
      }
      let that = this;
	    that.$dialog.alert({
		    message: '需要您的位置信息',
		    className: 'percen_button_alert',
		    cancelButtonColor: '#FC0324',
		    confirmButtonColor: '#FFFCFC',
		    confirmButtonText: '确定',
		    closeOnPopstate: false
	    }).then(function () {
			wx.getLocation({
				type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
				success: function(res) {
					that.latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
					that.longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
					// var speed = res.speed; // 速度，以米/每秒计
					// var accuracy = res.accuracy; // 位置精度
					that.getData(res.longitude, res.latitude)
				}
			});
	    })
    },
    getData (lng, lat) {
      var url = 'Wxmall/VipGift/getRegistItem?user_longitude=' + lng + '&user_latitude=' + lat
      this.$customRequestAjax(url).then(res => {
        if (res.data.code == 200) {
          this.superinfo = {
            supername: res.data.supername,
            superimg: res.data.superimg,
            supermobile: res.data.supermobile
          }
          this.paymoney = res.data.paymoney
          this.maxmoney = res.data.maxmoney
          this.minmoney = res.data.minmoney
          this.list = res.data.giftitemlist
          this.list.map((item, index) => {
            item.itemlist.map((goodsitem, goodsindex) => {
              goodsitem.chooseid = index + '-' + goodsindex
              goodsitem.num = 0
            })
          })
          console.log(this.taglist, this.list)
        }
      })
    },
    scrollTop () {
      let oBox = this.$refs.productlist
      let divlist = oBox.children, i = 0
      for (let item of divlist) {
        let target = item.offsetTop - oBox.offsetTop
        if (target - oBox.scrollTop <= 20 && target - oBox.scrollTop > -20) {
          console.log(i, target, oBox.scrollTop)
          this.activeKey = i
        } else if (oBox.scrollTop >= oBox.scrollHeight - oBox.offsetHeight) {
          this.activeKey = i
        }
        i++
      }
    },
    // 点击滚动
    handleClick(i) {
      let oBox = this.$refs.productlist
      // 网页可见区域高：document.body.clientHeight
      // 网页正文全文高：document.body.scrollHeight
      // 网页可见区域高（包括边框的高）：document.body.offsetHeight
      // 网页被卷去的高：document.body.scrollTop

      // 连续点击先清除定时器
      clearInterval(this.timer)
      let div = oBox.children[i]

      // 21:如果外层盒子距离浏览器顶部有margin(注意包括盒子的边框)
      let target = div.offsetTop - oBox.offsetTop;

      this.timer = setInterval( () => {
        // 步长,速度
        let speed = (target - oBox.scrollTop)/5;

        speed = speed > 0 ? Math.ceil(speed) : Math.floor(speed)

        // console.log(speed)

        oBox.scrollTop = oBox.scrollTop + speed;

        // 滚动条是否已经到底: 盒子被卷去的高度+盒子可见区域的高度 = 盒子正文的总高度
        let isBottom = (oBox.scrollTop + oBox.clientHeight ===  oBox.scrollHeight)
		console.log(speed,isBottom);
		if(speed == 0 ||speed == -1 || isBottom){
          clearInterval(this.timer)
        }
      }, 30);
    },
    stepperFn () {
      this.onChange()
    },
    onChange () {
      this.totalmoney = 0
      this.shopConfirmResult = {
        skuidArr: [],
        itemNum: [],
        totalmoney: 0,
        paymoney: this.paymoney ? parseFloat(this.paymoney).toFixed(2) : '6000.00',
        totalnum: []
      }
      this.shopConfirmProductList = []
      this.list.map(item => {
        item.itemlist.map(goodsitem => {
          if (this.result.indexOf(goodsitem.chooseid) >= 0) {
            this.totalmoney += (parseFloat(goodsitem.price) * parseInt(goodsitem.num))
            this.shopConfirmResult.skuidArr.push(goodsitem.id)
            this.shopConfirmResult.itemNum.push(goodsitem.num)
            this.shopConfirmProductList.push(goodsitem)
          }
        })
      })
      if (this.totalmoney > this.maxmoney) {
        this.ismore = 2
        this.gapmoney = parseFloat(this.totalmoney - this.maxmoney).toFixed(2)
      } else if (this.totalmoney < this.minmoney) {
        this.ismore = 0
        this.gapmoney = parseFloat(this.minmoney - this.totalmoney).toFixed(2)
      } else {
        this.shopConfirmResult.totalmoney = this.totalmoney.toFixed(2)
        this.ismore = 1
      }
      console.log(this.totalmoney)
    },
    submit () {
      if (this.ismore != 1) {
        this.$toast(`礼包金额需大于等于${this.minmoney}且小于等于${this.maxmoney},请重新选择`)
        return
      }
      this.shopConfirmProductList.map(item => {
        item.img_path = item.path
        item.spec = item.skuname
        item.skuid = item.id
      })
      sessionStorage.setItem('shopConfirmResult_vipgift', JSON.stringify(this.shopConfirmResult))
      sessionStorage.setItem('shopConfirmProduct_vipgift', JSON.stringify(this.shopConfirmProductList))
      sessionStorage.setItem('superinfo', JSON.stringify(this.superinfo))
      this.$router.push('/vipgiftbagaddorder')
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/common/css/createmeeting";
  .van-cell-group--inset {
    margin-bottom: 0.1rem;
    margin-left: 0.05rem;
    padding: 0.05rem 0;
    .title_bold .van-cell__title {
      font-weight: bold;
    }
  }
  .title_bold {
    padding-bottom: 0;
  }
  .title_bold::after {
    display: none;
  }
.vipgiftbaglist {
  header {
    position: relative;
    img {
      width: 100%;
    }
    .van-button--mini {
      height: auto;
      position: absolute;
      right: 6%;
      top: 28%;
      color: #726D73!important;
    }
  }
  .content {
    .van-sidebar {
      height: calc(100vh - 2.16rem);
      background: #ffffff;
      .van-sidebar-item {
        background: transparent;
        color: #292929;
        padding: 0.1rem;
      }
      .van-sidebar-item--select {
        background: #f5f5f5;
        color: #FB6E38;
        &::before {
          display: none;
        }
      }
    }
    .productlist {
      height: calc(100vh - 2.16rem);
      overflow: auto;
    }
    .listitem {
      img {
        margin-left: 0.05rem;
        width: 0.5rem;
        height: 0.5rem;
      }
      .product {
        min-height: 0.6rem;
        margin-left: 0.07rem;
        p {
          color: #333333;
        }
        .price {
          color: #FB6E38;
          font-weight: bold;
        }
      }
    }
  }
  .footer {
    /*background: #ffffff;*/
    padding: 0.1rem 0.15rem;
    position: fixed;
    bottom: 0;
    width: 100%;
    .van-button--primary {
      font-size: 0.15rem;
      border-radius: 0.25rem;
      color: #FB6E38 !important;
      &.white {
        color: #ffffff !important;
      }
    }
    .h {
      height: 0.1rem;
    }
  }
}
</style>
<style lang="scss">
  .vipgiftbaglist {
    .van-checkbox__label {
      flex: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/upgradeVIP/vipgiftbaglist.vue